import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgOven = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M2.998 2.998H21v7H2.998zM6 18v-6H2.998v9H21v-9H18v6zM.998 3a2 2 0 0 1 2-2.001H21a2 2 0 0 1 2 2V21a2 2 0 0 1-2 2H2.998a2 2 0 0 1-2-2zm7.002 9v4h8v-4zm-1-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5.998-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4.002 1a1 1 0 1 0 0-2.001 1 1 0 0 0 0 2"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgOven);
export default Memo;
